<template>
  <div class="py5 w-100 pointer relative">
    <span
      class="filter-label cl-light-gray start-xs"
      @click="$emit('change', variant)"
      :aria-label="variant.label"
      :class="{'active': isActive}"
    >
      {{ variant.label }}
    </span>
  </div>
</template>
<script>
import filterMixin from 'theme/mixins/filterMixin.ts'
export default {
  mixins: [filterMixin]
}
</script>
<style lang="scss" scoped>
@import '~theme/css/variables/colors';
@import '~theme/css/helpers/functions/color';
$main: color(main);
$gray: color(gray);
.filter-label {
  font-size: 0.9em;
  &:hover {
   &::before {
      background: $gray;
    }
    &:after {
      content: "";
      position: absolute;
      left: 5px;
      top: 14px;
      border-bottom: 2px solid #FFF;
      border-right: 2px solid #FFF;
      transform: rotate(45deg);
      width: 2px;
      height: 5px;
    }
  }
  &::before {
    content: "";
    display: inline-block;
    position: relative;
    top: 2px;
    margin-right: 10px;
    min-width: 12px;
    min-height: 12px;
    border: 1px solid #CCCCCC;
  }
  &.active {
    &::before {
      background: $main;
    }
    &:after {
      content: "";
      position: absolute;
      left: 5px;
      top: 14px;
      width: 2px;
      height: 5px;
      border-bottom: 2px solid #FFF;
      border-right: 2px solid #FFF;
      transform: rotate(45deg);
    }
  }
}
</style>
